import React from "react";
import { Box, Button, DataTable, Spinner, Text } from "grommet";
import useTocRecord from "../hooks/useTocRecord";

const TocRecordsBox = (props: any) => {
    const [received, setReceived] = React.useState(false);
    const [tocRecords, setTocRecords] = React.useState([]);
    const [recordData, setRecordData] = React.useState<any>([]);
    const [recordCol, setRecordCol] = React.useState<any>([]);
    const [columns, setColumns] = React.useState<any>([]);
    const [ready, setReady] = React.useState(false);
    const columnsExcluded = [
        "number",
        "book_id",
        "book_category",
        "numeration",
        "pub_date",
        "publisher",
        "pname",
        "record_page",
        "person_id",
        "school_id",
        "school_name",
        "book_title",
        "toc_title",
        "toc_id",
        "입력자비고",
        "발행"
    ];

    let toc = props.tocinfo;

    React.useEffect(() => {
        const receiveData = async () => {
            const res = await useTocRecord.getTocRecordsById(toc.toc_id);
            setTocRecords(res.tocrecords);
            setReceived(true);
        };
        receiveData();
    }, []);
    React.useEffect(() => {
        if (received && tocRecords.length > 0) {
            let records: any = [];
            let cols = ["이름"];
            tocRecords.forEach((r: any) => {
                let a_record:any = {}
                let replaced_text = [
                    "{",
                    "}",
                    "[",
                    "]",
                    '"',
                    "'",
                    "(근무지 또는 현주소)",
                    "(주소1?확인요)",
                    "(주소2?확인요)0",
                    "(주소2?확인요)",
                ];
                let record_text = r.record_text
                replaced_text.forEach((t: any) => {
                    record_text = record_text.replaceAll(t, '')
                })

                let r_div = record_text.split(',')
                // console.log(r_div)
                r_div.forEach((d: any) => {
                    let d_div = d.split(':')
                    let k = d_div[0].replaceAll(' ', '')
                    if(!columnsExcluded.includes(k) && d_div.length > 1){
                        a_record[k] = d_div[1]
                    } else if (d_div.length === 1) {
                        a_record['이름']  += ' '+d_div[0]
                    }
                })

                let keys = Object.keys(a_record);
                keys.forEach((k: any) => {
                    if (!columnsExcluded.includes(k) && !cols.includes(k)) {
                        cols.push(k);
                    }
                });
                records.push(a_record);
            });
            setRecordData(records);
            setColumns(cols);
        }
    }, [received, tocRecords]);
    React.useEffect(() => {
        let cols_object: any = [];
        let col_bold = ["이름"];
        let col_wide = ["주소"];
        columns.map((c: any) => {
            let primaryValue = false;
            let pinValue = false;
            if (c === "이름") {
                primaryValue = true;
                pinValue = true;
            }
            let colSizeValue = "small";
            if (col_wide.includes(c)) {
                colSizeValue = "small";
            } else if (c=='이름'){
                colSizeValue = "100px"
            }
            let a_col = {
                property: c,
                header: <Text size="12px">{c}</Text>,
                primary: primaryValue,
                pin: pinValue,
                size: colSizeValue,
                render: (datum: any) =>
                    col_bold.includes(c) ? (
                        <Box
                            style={{
                                minWidth: colSizeValue,
                            }}
                            pad={{ horizontal: "2px" }}
                        >
                            <Text size="13px" weight="bold">
                                {datum[c] ? (
                                    <Text size="13px">{datum[c]}</Text>
                                ) : (
                                    <Text size="10px" color="grey">
                                        -
                                    </Text>
                                )}
                            </Text>
                        </Box>
                    ) : (
                        <Box
                            style={{
                                minWidth: colSizeValue,
                            }}
                            pad={{ horizontal: "2px" }}
                        >
                            <Text size="13px">
                                {datum[c] ? (
                                    <Text size="13px">{datum[c]}</Text>
                                ) : (
                                    <Text size="10px" color="grey">
                                        -
                                    </Text>
                                )}
                            </Text>
                        </Box>
                    ),
            };
            cols_object.push(a_col);
        });
        setRecordCol(cols_object)
        setReady(true);
    }, [columns]);

    return (
        <>
            {ready && (
                <Box style={{ minHeight: "100px", minWidth: "400px" }}>
                    <DataTable
                        fill
                        step={10}
                        show={20}
                        background={{ pinned: "light-2" }}
                        data={recordData}
                        columns={recordCol}
                        pin
                        size=""
                        placeholder={
                            recordData.length === 0 && (
                                <Box
                                    fill
                                    align="center"
                                    justify="center"
                                    direction="row"
                                    pad="large"
                                    gap="small"
                                    background={{
                                        color: "background-front",
                                        opacity: 0.1,
                                    }}
                                >
                                    <Spinner />
                                    <Text weight="bold">Loading ...</Text>
                                </Box>
                            )
                        }
                    />
                </Box>
            )}
        </>
    );
};

export default TocRecordsBox;
